import {utils_tool,component_tool} from '@/tool';
import React from 'react'
import moment from "moment";
let { WizModal } = component_tool
let {$$, checkStrLength} = utils_tool;
//配置项
let componentName = 'temporaryAccountRelation'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "账号",
    name: "userNameSearch",
    searchItem: {}
  },
  {
    title: "登录账号",
    name: "gatewayUserName",
    tableItem: {
      width: 200
    }
  },
  {
    title: "登录账号姓名",
    name: "gatewayFullName",
    tableItem: {
      width: 200
    }
  },
  {
    title: "关联身份证号码",
    name: "idCardSearch",
    searchItem: {}
  },
  {
    title: "关联身份证号码",
    name: "idCard",
    tableItem: {
      width: 200
    }
  },
  {
    title: "关联临时账号",
    name: "temporaryUserName",
    tableItem: {
      width: 200
    }
  },
  {
    title: "关联临时账号姓名",
    name: "temporaryFullName",
    tableItem: {
    }
  },
];

const templateConfig = (data) => {
  const { _this} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (val) => {
            return val
          },
          collapse: false,
          buttonSort: [],
          buttons: [
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          isScroll: true,
          loading: false,
        },
        rowOperateSort:['delete'],
        rowOperateView: [
          {
            key: "delete",
            custom: true,
            params: { children: "删除"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "delete",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '您是否确认删除当前选择的账号询问信息？'
                let ids = [record['id']];
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ids
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
        ],
        commonOperate: {
          delete: true
        }
      }
    }
  };
};

const apis = {
  list: {
    path: `${componentName}/pageList`,
    payload: {
      key: `${componentName}@pageList`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
